import React, {useContext, useEffect, useState} from 'react';
import {observer} from "mobx-react-lite";
import {Context} from "../../../index";
import {delGenre, delLanguage, fetchGenre, fetchLanguages} from "../../../http/bookAPI";
import Modal from "react-bootstrap/Modal";
import {Dropdown, Form, Spinner} from "react-bootstrap";

const DeleteLanguage = observer(({ show, handleClose }) => {
    const {book} = useContext(Context)
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchLanguages().then(data => book.setLanguages(data))
    }, []);

    const killLanguage = async () => {
        setLoading(true);
        setError('');
        try {
            // Отправляем DELETE запрос с параметром id в URL
            await delLanguage(book.selectedLanguage.id); // Просто передаём ID языка
            const updatedLanguages = await fetchLanguages(); // Обновляем список жанров
            book.setLanguages(updatedLanguages);
            book.setSelectedLanguage({}); // Сбрасываем выбранный language
            setValue(''); // Очищаем поле ввода
            handleClose(); // Закрываем модальное окно
        } catch (e) {
            const errorMessage = e.response?.data?.message || 'An error occurred while adding the language.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={() => {
            setError('');
            handleClose();
        }} centered>

            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Delete language</h1>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            setError('');
                            handleClose();
                        }}
                    ></button>
                </div>

                <div className="card">
                    <div className="card-body">

                        <div className="d-flex justify-content-center mt-3">

                            <Dropdown className="dropdown-center">
                                <Dropdown.Toggle variant="success" className="shadow">
                                    {book.selectedLanguage.language || "Select Language to Delete"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {book.languages.map((lan) => (
                                        <Dropdown.Item
                                            onClick={() => {book.setSelectedLanguage(lan);
                                                setValue(lan.language);
                                            }}
                                            key={lan.id}
                                        >
                                            {lan.language}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
                <div className="modal-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <Form>
                        <Form.Control
                            value={value}
                            onChange={(e) => setValue(e.target.value)}

                            disabled={true} // Отключаем, если ничего не выбрано
                        />
                    </Form>
                </div>
                <div className="modal-footer">

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={killLanguage}
                        disabled={!value.trim() || loading}
                    >
                        {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Delete from DB'}
                    </button>

                </div>
            </div>
        </Modal>
    );
});



export default DeleteLanguage;